const nameSpace = 'drawer'

export const drawerType = {
  LOGIN_LP_DRAWER: 'LoginLpDrawer',
  ADVERTISER_DRAWER: 'AdvertiserDrawer',
  ADMIN_DRAWER: 'AdminDrawer',
  NULL: '',
}

export const mutations = {
  SET_DRAWER_FLAG: `${nameSpace}/SET_DRAWER_FLAG`,
  SET_DRAWER_TYPE: `${nameSpace}/SET_DRAWER_TYPE`,
  SET_DRAWER_TOGGLE_BUTTON_VISIBILITY: `${nameSpace}/SET_DRAWER_TOGGLE_BUTTON_VISIBILITY`,
}

export const actions = {
  SHOW_DRAWER: `${nameSpace}/SHOW_DRAWER`,
  TOGGLE_DRAWER: `${nameSpace}/TOGGLE_DRAWER`,
  CHANGE_DRAWER_TYPE: `${nameSpace}/CHANGE_DRAWER_TYPE`,
  CHANGE_DRAWER_TOGGLE_BUTTON_VISIBILITY: `${nameSpace}/CHANGE_DRAWER_TOGGLE_BUTTON_VISIBILITY`,
}

export const getters = {
  drawerType: `${nameSpace}/drawerType`,
  showFlag: `${nameSpace}/showFlag`,
  toggleButton: `${nameSpace}/toggleButton`,
}
